import { Map, List } from "immutable";
import { selectData } from "fe-shared/utils/reducerUtils";

import {
  STATE_CONFIG,
  STATE_CONFIG_DATA,
  STATE_CONFIG_STYLES,
  STATE_CONFIG_PERSISTENT_MENU,
  STATE_CONFIG_IMAGE_URL,
  STATE_CONFIG_GREETING_TEXT,
} from "./default";

export const getConfig = state => selectData(state, STATE_CONFIG);
export const getConfigData = state =>
  selectData(getConfig(state), STATE_CONFIG_DATA);
export const getConfigDataStyles = state =>
  selectData(getConfigData(state), STATE_CONFIG_STYLES, Map());
export const getConfigDataPersistentMenu = state =>
  selectData(getConfigData(state), STATE_CONFIG_PERSISTENT_MENU, List());
export const getConfigDataImageUrl = state =>
  selectData(getConfigData(state), STATE_CONFIG_IMAGE_URL);
export const getConfigDataGreetingText = state =>
  selectData(getConfigData(state), STATE_CONFIG_GREETING_TEXT);
